import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { User } from '../models/auth.models';
import { baseURL } from '../constants/base.url';
import { map } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserProfileService {

    constructor(private http: HttpClient) { }

    // Update password method
    updatePassword(currentPassword: string, newPassword: string): Observable<any> {
        const body = { currentPassword, newPassword };
        return this.http.put(`${baseURL}auth/update-password`, body).pipe(
            catchError(this.handleError)
        );
    }

    // Forget password method (for reset token)
    forgetPassword(email: string): Observable<any> {
        return this.http.post(`${baseURL}auth/forgot-password`, { email }).pipe(
            catchError(this.handleError)
        );
    }

    // Reset password method
    resetPassword(email: string, otp: string, newPassword: string): Observable<any> {
        return this.http.post(`${baseURL}auth/reset-password`, {
            email,
            otp,
            newPassword
        }).pipe(
            catchError(this.handleError)
        );
    }


    // Get current user profile
    getUserProfile(): Observable<any> {
        return this.http.get(`${baseURL}auth/profile`).pipe(
            catchError(this.handleError)
        );
    }

    // Create User
    createUser(userData: FormData): Observable<any> {
        return this.http.post(`${baseURL}auth/register`, userData)
    }

    // Delete user by ID (admin only)
    deleteUser(userId: string): Observable<any> {
        return this.http.delete(`${baseURL}auth/user/delete/${userId}`).pipe(
            catchError(this.handleError)
        );
    }

    // Get all users (admin only)
    getAllUsers(): Observable<any> {
        return this.http.get(`${baseURL}auth/users`).pipe(
            catchError(this.handleError)
        );
    }

    // Update user profile
    updateUserProfile(formData: FormData): Observable<any> {
        return this.http.put(`${baseURL}auth/update`, formData).pipe(
            catchError(this.handleError)
        );
    }

    // Update user profile
    updateUsers(userId: string, updatedData: any): Observable<any> {
        return this.http.put(`${baseURL}auth/admin/user/${userId}`, updatedData).pipe(
            catchError(this.handleError)
        );
    }


    // Get single user (admin only)
    getSingleUser(userId: string): Observable<any> {
        return this.http.get(`${baseURL}auth/user/${userId}`).pipe(
            catchError(this.handleError)
        );
    }

    getAllCustomers(): Observable<User[]> {
        return this.getAllUsers().pipe(
            map((res: any) => {
                // agar backend `users` key ke andar bhej raha hai
                const users: User[] = res.users || res;
                return users.filter(u => u.role === 'retail_customer');
            })
        );
    }

    // Handle errors during HTTP requests
    private handleError(error: any) {
        let errorMessage = 'An unknown error occurred!';
        if (error.error instanceof ErrorEvent) {
            errorMessage = `An error occurred: ${error.error.message}`;
        } else {
            errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
        }
        return throwError(errorMessage); // Use throwError instead of Observable.throw
    }
}